import { create } from "zustand";

type ListKey = string;

interface GenericListStore {
  lists: Record<ListKey, string[]>;
  addItem: (list: ListKey, item: string) => void;
  removeItem: (list: ListKey, item: string) => void;
  moveItem: (from: ListKey, to: ListKey, item: string) => void;
  setList: (list: ListKey, items: string[]) => void;
}

export const useGenericListStore = create<GenericListStore>((set) => ({
  lists: {},
  addItem: (list, item) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [list]: [...(state.lists[list] || []), item],
      },
    })),
  removeItem: (list, item) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [list]: (state.lists[list] || []).filter((i) => i !== item),
      },
    })),
  moveItem: (from, to, item) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [from]: (state.lists[from] || []).filter((i) => i !== item),
        [to]: [...(state.lists[to] || []), item],
      },
    })),
  setList: (list, items) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [list]: items,
      },
    })),
}));